import request from '@/utils/request'

export function getReasonCancelApi(query) {
  return request({
    url: '/config-service/v1/cancel-reason/list',
    method: 'get',
    params: query
  })
}

export function addReasonCancelApi(query) {
  return request({
    url: '/config-service/v1/cancel-reason/add',
    method: 'post',
    data: query
  })
}

export function updateReasonCancelApi(query) {
  return request({
    url: '/config-service/v1/cancel-reason/update',
    method: 'put',
    data: query
  })
}
export function deleteReasonCancelApi(query) {
  return request({
    url: '/config-service/v1/cancel-reason/delete',
    method: 'delete',
    data: query
  })
}
